<div #container class="slider-container" [ngClass]="{'active': dragging, thin: size==='thin'}">
	<div class="slider-background" ></div>
	<div class="slider" #slider [ngStyle]="progress">
		<div class="background"></div>
		<div class="handle" #handle>
			<div class="value label-above">{{ displayValue }}{{ displaySuffix }}</div>
		</div>
	</div>

	<input type="range" tabindex="0" role="slider" class="range-slider" [min]="min" [max]="max" [step]="step" [value]="innerValue" (mousedown)="toggleDragging(true)" (mouseup)="toggleDragging(false)" (input)="setPosition($event.target.value)" (change)="setPosition($event.target.value)" (touchstart)="toggleDragging(true)" (touchend)="setPosition($event.target.value);toggleDragging(false)" (touchmove)="setPosition($event.target.value)" />
</div>
